import React from 'react';

import { MenuList } from '@atlaskit/navigation-system/side-nav-items/menu-list';
import { Divider, MenuSection } from '@atlaskit/navigation-system/side-nav-items/menu-section';
import { fg } from '@atlaskit/platform-feature-flags';
import { NavErrorBoundary } from '@atlassian/navigation-error-boundary';

import type { MenuItemConfigData } from '../../../types';

import type { MenuItemComponentProps } from './types';

export function MoreMenuSection({
	itemsData,
	moreMenuItemComponent,
	closeMenu,
}: MenuItemComponentProps): React.JSX.Element | null {
	if (itemsData.length === 0) {
		return null;
	}

	const MenuItemComponent = moreMenuItemComponent;

	return (
		<MenuSection isMenuListItem>
			<MenuList>
				{itemsData.map(({ menuId }: MenuItemConfigData) => {
					const item = <MenuItemComponent menuId={menuId} key={menuId} closeMenu={closeMenu} />;
					return !fg('navx-1574-navigation-error-boundary') ? (
						item
					) : (
						<NavErrorBoundary location="more-menu-item-component" showFlags key={menuId}>
							{item}
						</NavErrorBoundary>
					);
				})}
			</MenuList>
			<Divider />
		</MenuSection>
	);
}
